<div class="h-full flex flex-col divide-y divide-zinc-950/10 dark:divide-white/10">

    <!-- Messages -->
    <div #messagesContainer class="flex-1 min-h-0 overflow-y-auto p-4 space-y-3">
        <div *ngIf="hasOlderMessages" class="flex justify-center">
            <button type="button" (click)="loadOlderMessages()" class="btn btn-outline-secondary sm:text-xs/5">
                Load older messages
            </button>
        </div>

        <p *ngIf="!messages.length" class="text-center text-sm-light">No messages yet</p>

        <ng-container *ngFor="let message of messages; trackBy: trackById">
            <div *ngIf="message.day" class="flex justify-center">
                <span class="badge-secondary">{{message.day}}</span>
            </div>

            <div class="flex max-w-[80%]" [ngClass]="{ 'ml-auto justify-end': message.isMine }">
                <div class="p-3 rounded-md text-zinc-800 dark:text-zinc-100"
                    [ngClass]="message.isMine ? 'bg-zinc-200 dark:bg-zinc-800' : 'bg-zinc-50 dark:bg-zinc-900 border border-zinc-950/10 dark:border-white/10'">
                    <div *ngIf="!message.isMine" class="text-xs font-medium text-main-dark mb-1">
                        {{message.sender?.name}} · {{roleLabels[message.senderType]}}
                    </div>

                    <p *ngIf="message.text" class="whitespace-pre-line break-words">{{message.text}}</p>

                    <div *ngFor="let attachment of message.attachments" class="mt-1">
                        <a [href]="attachment.url" target="_blank" rel="noopener">
                            <img *ngIf="attachment.isImage; else fileLink" [src]="attachment.url" [alt]="attachment.name" loading="lazy"
                                class="max-h-48 rounded-md" />
                            <ng-template #fileLink>
                                <span class="underline text-sm break-all">{{attachment.name}}</span>
                            </ng-template>
                        </a>
                    </div>

                    <div class="text-xs text-zinc-500 dark:text-zinc-400 mt-1 text-right">
                        {{message.time}}
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <!-- Composer -->
    <div *ngIf="isClosed" class="px-4 py-3 text-center text-sm-light">
        This ticket is closed
    </div>
    <form *ngIf="!isClosed" (ngSubmit)="sendMessage()" class="px-4 py-2 space-y-2">
        <div *ngIf="attachments.length" class="flex flex-wrap gap-2">
            <span *ngFor="let attachment of attachments; let i = index" class="badge-secondary flex items-center gap-1">
                {{attachment.name}}
                <button type="button" (click)="removeAttachment(i)" title="Remove">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                    </svg>
                </button>
            </span>
        </div>
        <textarea rows="3" name="text" [(ngModel)]="text" class="block w-full min-h-16 py-3 sm:text-sm"
            placeholder="Type a message ....."></textarea>
        <div class="flex justify-between items-center">
            <label class="cursor-pointer text-sm-light hover:text-zinc-950 dark:hover:text-white flex items-center gap-1">
                <input type="file" multiple class="hidden" (change)="onSelectFiles($event)" [disabled]="isUploading" />
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">
                    <path stroke-linecap="round" stroke-linejoin="round"
                        d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                </svg>
                {{isUploading ? 'Uploading...' : 'Attach'}}
            </label>
            <button type="submit" class="btn btn-secondary" [disabled]="isUploading || isSending">
                {{isSending ? 'Sending...' : 'Send'}}
            </button>
        </div>
    </form>
</div>
